import { Svg, Path, Rect } from "@react-pdf/renderer";

export const SentimentVerySatisfied = (): JSX.Element => (
	<Svg width="60" height="60" viewBox="0 0 60 60">
		<Rect width="60" height="60" fill="#55A630" x={0} y={0} />
		<Path
			d="M37 28C38.6569 28 40 26.6569 40 25C40 23.3431 38.6569 22 37 22C35.3431 22 34 23.3431 34 25C34 26.6569 35.3431 28 37 28Z"
			fill="black"
		/>
		<Path
			d="M23 28C24.6569 28 26 26.6569 26 25C26 23.3431 24.6569 22 23 22C21.3431 22 20 23.3431 20 25C20 26.6569 21.3431 28 23 28Z"
			fill="black"
		/>
		<Path
			d="M29.98 10C18.94 10 10 18.96 10 30C10 41.04 18.94 50 29.98 50C41.04 50 50 41.04 50 30C50 18.96 41.04 10 29.98 10ZM30 46C21.16 46 14 38.84 14 30C14 21.16 21.16 14 30 14C38.84 14 46 21.16 46 30C46 38.84 38.84 46 30 46ZM20 34C21.56 38.68 25.44 42 30 42C34.56 42 38.44 38.68 40 34H20Z"
			fill="black"
		/>
	</Svg>
);
